import React from "react";
import twoBg from "../../assets/images/background/image-5.jpg";
import threebg from "../../assets/images/background/image-56.jpg";
import fourbg from "../../assets/images/background/image-6.jpg";
import { Link } from "react-router-dom";
import bg12 from "../../assets/images/background/bg-12.png";
import bg13 from "../../assets/images/background/bg-13.png";

function Services() {
    return (
        <>
            <section className="fluid-section">
                <div className="outer-container">
                    <div className="row clearfix">
                        <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div
                                className="inner wow fadeInLeft"
                                data-wow-duration="1500ms"
                                data-wow-delay="0ms"
                            >
                                <div
                                    className="image-layer"
                                    style={{ backgroundImage: `url(${twoBg})` }}
                                ></div>

                                <div className="image">
                                    <img src={twoBg} alt="" />
                                </div>
                            </div>
                        </div>

                        <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div
                                className="inner clearfix wow fadeInRight"
                                data-wow-duration="1500ms"
                                data-wow-delay="0ms"
                            >
                                <div className="content-box">
                                    <div className="title-box centered">
                                        <div className="subtitle">
                                            <span>
                                                Breakfast worth waking up for
                                            </span>
                                        </div>
                                        <div className="pattern-image">
                                            <img
                                                src={
                                                    require("../../assets/images/icons/separator.svg")
                                                        .default
                                                }
                                                alt="mySvgImage"
                                            />
                                        </div>
                                        <h2>Breakfast</h2>
                                        <div className="text">
                                            Our menu has over 60 items to choose
                                            from, ensuring that there are
                                            options for everyone. Choose from a
                                            selection of Smoothies, Traditional
                                            Breakfasts, Pancakes, French Toast,
                                            Waffles, Crêpes, Omelettes, and Eggs
                                            Benedict.
                                            <br />
                                            <br /> We have many Gluten-Free
                                            options as well as a Vegan option so
                                            no one will be left out. <br />
                                            <br /> All our breakfasts are
                                            complimented with Hand-Cut Potatoes
                                            topped with François Special
                                            Seasoning and Fresh Fruit.
                                            <br />
                                            <br /> Still, having trouble
                                            deciding? Don’t worry we have a
                                            great selection of combos as well,
                                            including Québec, American, and
                                            Sweet-Bene Combos.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="fluid-section alternate">
                <div className="outer-container">
                    <div className="row clearfix">
                        <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div
                                className="inner wow fadeInLeft"
                                data-wow-duration="1500ms"
                                data-wow-delay="0ms"
                            >
                                <div
                                    className="image-layer"
                                    style={{
                                        backgroundImage: `url(${threebg})`,
                                    }}
                                ></div>
                                <div className="image">
                                    <img src={threebg} alt="" />
                                </div>
                            </div>
                        </div>

                        <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div
                                className="inner clearfix wow fadeInRight"
                                data-wow-duration="1500ms"
                                data-wow-delay="0ms"
                            >
                                <div className="content-box">
                                    <div className="title-box centered">
                                        <div className="subtitle">
                                            <span>your Canmore lunch spot</span>
                                        </div>

                                        <div className="pattern-image">
                                            <img
                                                src={
                                                    require("../../assets/images/icons/separator.svg")
                                                        .default
                                                }
                                                alt="mySvgImage"
                                            />
                                        </div>

                                        <h2>Lunch</h2>
                                        <div className="text">
                                            Not feeling like breakfast?
                                            <br />
                                            <br />
                                            We have a French bistro-style lunch
                                            menu that includes Sandwiches,
                                            Burgers, Salads, Savory Crêpes,
                                            Poutine, and Specialties like Liver
                                            and Onions.
                                            <br />
                                            <br />
                                            Compliment your lunch with a glass
                                            of wine, a local beer, or a homemade
                                            cocktail.
                                        </div>
                                    </div>
                                    <div className="link-box">
                                        <Link
                                            to="https://swyeat.com/index.html?businessId=69168f8f-827d-4d64-9718-c508cde0fed8&source=webMenu"
                                            className="theme-btn btn-style-two clearfix"
                                        >
                                            <span className="btn-wrap">
                                                <span className="text-one">
                                                    view all menu
                                                </span>
                                                <span className="text-two">
                                                    view all menu
                                                </span>
                                            </span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="fluid-section">
                <div className="outer-container">
                    <div className="row clearfix">
                        <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div
                                className="inner wow fadeInLeft"
                                data-wow-duration="1500ms"
                                data-wow-delay="0ms"
                            >
                                <div
                                    className="image-layer"
                                    style={{
                                        backgroundImage: `url(${fourbg})`,
                                    }}
                                ></div>

                                <div className="image">
                                    <img src={fourbg} alt="" />
                                </div>
                            </div>
                        </div>

                        <div className="content-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <div
                                className="inner clearfix wow fadeInRight"
                                data-wow-duration="1500ms"
                                data-wow-delay="0ms"
                            >
                                <div className="content-box">
                                    <div className="title-box centered">
                                        <div className="subtitle">
                                            <span>
                                                Breakfast worth waking up for
                                            </span>
                                        </div>
                                        <div className="pattern-image">
                                            <img
                                                src={
                                                    require("../../assets/images/icons/separator.svg")
                                                        .default
                                                }
                                                alt="mySvgImage"
                                            />
                                        </div>
                                        <h2>Catering & Wedding</h2>
                                        <div className="text">
                                            We also do private functions and
                                            caterings for all of your
                                            celebration needs.
                                            <br />
                                            <br /> We have 2 private rooms with
                                            up to 120 seats, a dance floor and a
                                            full bar. <br />
                                            <br /> Our chef and owner François
                                            will work with you to create the
                                            perfect menu for your occasion.
                                            <br />
                                            <br /> Give us a call to start your
                                            planning!
                                        </div>
                                    </div>
                                    <div className="link-box">
                                        <Link
                                            to="https://swyeat-events-storage.s3.ca-central-1.amazonaws.com/Wedding+Menu+Guide.pdf"
                                            className="theme-btn btn-style-two clearfix"
                                        >
                                            <span className="btn-wrap">
                                                <span className="text-one">
                                                    menu guides
                                                </span>
                                                <span className="text-two">
                                                    menu guides
                                                </span>
                                            </span>
                                        </Link>
                                    </div>
                                    <div className="link-box">
                                        <Link
                                            to="https://swyeat-events-storage.s3.ca-central-1.amazonaws.com/Wedding+Menu+Guide.pdf"
                                            className="theme-btn btn-style-two clearfix"
                                        >
                                            <span className="btn-wrap">
                                                <span className="text-one">
                                                    wedding menu
                                                </span>
                                                <span className="text-two">
                                                    wedding menu
                                                </span>
                                            </span>
                                        </Link>
                                    </div>

                                    <div className="link-box">
                                        <div className="more-link">
                                            <Link to="#">
                                                Booking : +1-403-678-6111
                                            </Link>
                                        </div>
                                        <li>
                                            <Link to="mailto:chezfrancoisbookings@gmail.com">
                                                chezfrancoisbookings@gmail.com
                                            </Link>
                                        </li>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Services;
